export const tableOption = {
  border: true,
  index: true,
  indexLabel: '序号',
  stripe: true,
  menuAlign: 'center',
  menuWidth: 150,
  align: 'center',
  refreshBtn: true,
  searchMenuSpan: 6,
  showClomnuBtn: false,
  searchSize: 'mini',
  addBtn: false,
  editBtn: false,
  viewBtn: true,
  props: {
    label: 'label',
    value: 'value'
  },
  column: [{
    label: '类型',
    prop: 'type',
    type: 'select',
    dicUrl: '/system/dict/type/log_type',
    search: true,
    width: 80,
  }, {
    label: '标题',
    prop: 'title',
    search: true,
    width: 120,
  }, {
    label: '用户',
    prop: 'createBy',
    search: true,
  }, {
    label: '请求URI',
    prop: 'requestUri',
    search: true,
    overHidden:true
  }, {
    label: '参数',
    prop: 'params',
    hide:true,
    overHidden:true
  }, {
    width: 80,
    label: '请求时间',
    prop: 'time'
  }, {
    label: '返回',
    prop: 'exception',
    hide:true,
  }, {
    width: 150,
    label: '创建时间',
    prop: 'createTime',
    type: 'datetime',
    format: 'yyyy-MM-dd HH:mm',
    valueFormat: 'yyyy-MM-dd HH:mm:ss',
  }, {
    width: 180,
    label: '异常日志',
    prop: 'exception',
    hide: true
  }]
}
